import { render, staticRenderFns } from "./ReviewsCategoriesFacilitiesDialogButton.vue?vue&type=template&id=47b10f0d&"
import script from "./ReviewsCategoriesFacilitiesDialogButton.vue?vue&type=script&lang=js&"
export * from "./ReviewsCategoriesFacilitiesDialogButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports